import { render, staticRenderFns } from "./PFormSelectAlt.vue?vue&type=template&id=6939a6f3&scoped=true&"
import script from "./PFormSelectAlt.vue?vue&type=script&lang=ts&"
export * from "./PFormSelectAlt.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelectAlt.vue?vue&type=style&index=0&id=6939a6f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6939a6f3",
  null
  
)

export default component.exports